import { useState } from 'react'
import { ToggleLabel } from './style'
export const Toggle = ({ label, toggled, onClick }) => {
  const [isToggled, toggle] = useState(toggled)

  const callback = () => {
    toggle(!isToggled)
    onClick(!isToggled)
  }

  return (
    <ToggleLabel>
      <input type="checkbox" defaultChecked={isToggled} onClick={callback} />
      <span />
      <strong>{label}</strong>
    </ToggleLabel>
  )
}
